import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Motels\MotelAiosellPropertyController::property
* @see app/Http/Controllers/Admin/Motels/MotelAiosellPropertyController.php:18
* @route '/motels/{motel}/aiosell/property'
*/
export const property = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: property.url(args, options),
    method: 'get',
})

property.definition = {
    methods: ["get","head"],
    url: '/motels/{motel}/aiosell/property',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAiosellPropertyController::property
* @see app/Http/Controllers/Admin/Motels/MotelAiosellPropertyController.php:18
* @route '/motels/{motel}/aiosell/property'
*/
property.url = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { motel: args }
    }

    if (Array.isArray(args)) {
        args = {
            motel: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        motel: args.motel,
    }

    return property.definition.url
            .replace('{motel}', parsedArgs.motel.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAiosellPropertyController::property
* @see app/Http/Controllers/Admin/Motels/MotelAiosellPropertyController.php:18
* @route '/motels/{motel}/aiosell/property'
*/
property.get = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: property.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAiosellPropertyController::property
* @see app/Http/Controllers/Admin/Motels/MotelAiosellPropertyController.php:18
* @route '/motels/{motel}/aiosell/property'
*/
property.head = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: property.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAiosellPropertyController::property
* @see app/Http/Controllers/Admin/Motels/MotelAiosellPropertyController.php:18
* @route '/motels/{motel}/aiosell/property'
*/
const propertyForm = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: property.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAiosellPropertyController::property
* @see app/Http/Controllers/Admin/Motels/MotelAiosellPropertyController.php:18
* @route '/motels/{motel}/aiosell/property'
*/
propertyForm.get = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: property.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Motels\MotelAiosellPropertyController::property
* @see app/Http/Controllers/Admin/Motels/MotelAiosellPropertyController.php:18
* @route '/motels/{motel}/aiosell/property'
*/
propertyForm.head = (args: { motel: string | number } | [motel: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: property.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

property.form = propertyForm

const aiosell = {
    property: Object.assign(property, property),
}

export default aiosell